<template>
  <div>
    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown v-if="activeModules.length > 0">
        <base-button slot="title" type="primary" class="dropdown-toggle">
          Product Management - {{ _.startCase(currentProfile) }}
        </base-button>
        <a
          v-for="profile in activeModules"
          :key="profile.id"
          @click.prevent="
            setCurrentProfile(
              _.pluralize(_.snakeCase(profile.name)),
              profile.id
            )
          "
          class="dropdown-item"
          href="#"
          >{{ profile.name }}</a
        >
      </base-dropdown>
      <base-dropdown v-else>
        <base-button slot="title" type="primary" class="dropdown-toggle">
          Product Management
        </base-button>
        <a class="dropdown-item" disabled
          >No active module/s under this feature</a
        >
      </base-dropdown>
    </base-header>

    <template v-if="currentProfile == 'products'">
      <div class="container-fluid mt--7">
        <div v-if="pxMode == 'products'" class="card mb-3">
          <div class="row no-gutters">
            <div class="col-md-6" style="padding: 15px; padding-left: 25px">
              <h3>Product Search</h3>
              <b-input-group>
                <template v-slot:prepend>
                  <b-dropdown :text="filterCaption" variant="outline-default">
                    <b-dropdown-item @click.prevent="changeFilter('name')"
                      >Description</b-dropdown-item
                    >
                    <b-dropdown-item @click.prevent="changeFilter('barcode')"
                      >Barcode</b-dropdown-item
                    >
                    <b-dropdown-item @click.prevent="changeFilter('stock_no')"
                      >Stock No</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click.prevent="changeFilter('reference_code')"
                      >Reference Code</b-dropdown-item
                    >
                    <b-dropdown-item @click.prevent="changeFilter('shelf_code')"
                      >Shelf Code</b-dropdown-item
                    >
                  </b-dropdown>
                </template>

                <b-form-input
                  style="padding: 5px; height: 44px"
                  v-model="searchText"
                  @keyup.enter="checkFilteringMethod"
                  >{{ searchText }}</b-form-input
                >

                <template v-slot:append>
                  <b-button
                    variant="outline-default"
                    @click.prevent="checkFilteringMethod"
                    ><span class="fa fa-search"
                  /></b-button>
                </template>
              </b-input-group>

              <br />
            </div>

            <div class="col-md-6">
              <!-- <b-form-checkbox v-if="filterField == 'barcode'"
                class="float-left ml-4"
                id="checkbox-1"
                style="margin-top: 8%;"
                v-model="isIncludeMatrixItem"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
              >
                Include Matrix Item
              </b-form-checkbox> -->
              <button
                class="btn btn-sm float-right mr-10"
                style="
                  margin-top: 10%;
                  margin-right: 5%;
                  background-color: #394a5d;
                  color: white;
                "
                @click.prevent="advanceFilter()"
              >
                {{ toggleLabel }}</button
              >&nbsp;&nbsp;
            </div>

            <div
              v-if="toggleAdvanceFilter"
              id="hide"
              class="col-md-12"
              style="border-top: 1px solid #e0e0e0; width: 100%"
            >
              <product-advance-filter
                :currentFilter="currentFilter"
                :parentParams="filterParams"
                :massUpdateMode="massUpdateMode"
                @changeParams="changeParams"
                @closeFilter="closeFilter"
                :key="filterKey"
              >
              </product-advance-filter>
            </div>

            <!-- Filter Params <br>
            {{filterParams}}
            <br>--------------------<br>
            Params <br>
            {{params}}
            <br>--------------------<br>
            Parent Params <br>
            {{parentParams}} -->
          </div>
        </div>
      </div>

      <div
        id="filterDiv"
        class="container-fluid col-md-12"
        v-if="pxMode == 'products'"
      >
        <small>Currently Applied Filters:</small> &nbsp;
        <div v-if="tags.length > 0">
          <template v-for="tag in tags">
            <a-tag
              :key="tag"
              :afterClose="() => handleClose(tag)"
              color="blue"
              closable
            >
              {{ tag }}
            </a-tag>
          </template>
          <button
            class="btn btn-sm"
            style="
              background-color: #394a5d;
              color: white;
              width: 10%;
              margin-right: 5%;"
            @click="clearFilter">
            Clear
          </button>
        </div>

        <div v-else>
          <a-tag> No filters applied</a-tag>
        </div>
      </div>

      <div class="col-md-12">
        <div
          v-if="pxMode == 'products' && accessRights.length > 0"
          class="card-body"
        >
          <!-- PRODUCT LIST -->
          <products-table
            title="Product List"
            :accessRights="accessRights"
            :params="params"
            :filterParams="filterParams"
            :tags="tags"
            :massUpdateMode="massUpdateMode"
            :key="componentKey"
            @changeMode="changeMode"
          ></products-table>
        </div>
      </div>
    </template>

    <template v-else-if="currentProfile == 'rte_configurations'">
      <rte-management></rte-management>
    </template>

    <template v-else-if="currentProfile == 'epay_configurations'">
      <epay-management></epay-management>
    </template>

    <template v-else-if="currentProfile == 'product_price_worksheets' || currentProfile == 'barcode_printings'">
      <div class="card mx-5 mb-3 mt--7">
        <div class="row no-gutters">
          <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
            <div class="card-body pb-2 pt-4">
              <document-filter v-if="docTypeChanged"
                @changeDocFilter="changeDocFilter"
              ></document-filter>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card-body pt-0">
              <documents-table v-if="docTypeChanged"
                :selectedDocumentName="selectedDocumentName"
                :documentType="documentType" :documentTypeDetails="documentTypeDetails"
              ></documents-table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="currentProfile == 'barcode_printing_templates'">
      <barcode-printing-template></barcode-printing-template>
    </template>

    <template v-else-if="currentProfile == 'serial_managers'">
      <serial-management></serial-management>
    </template>
  </div>
</template>

<script>
import ProductsTable from "../Tables/ProductsTableV2";
import ProductAdvanceFilter from "../Products/ProductAdvanceFilter.vue";
import secureStorage from "../../controllers/secureStorage.js";
import HTTPRequest from "../../controllers/httpRequest.js";
import DynamicForm from "../DynamicForm.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import DocumentFilter from "./../DocumentFilter";
import DocumentsTable from "../Tables/DocumentsTable.vue";
import RteManagement from "./RteManagement.vue";
import EpayManagement from "./EpayManagement.vue";
import SerialManagement from "./SerialManagement.vue";
import BarcodePrintingTemplate from "./BarcodePrintingTemplate.vue";
var component_x;

var ObjGen = require("../../../node_modules/objgen/objgen.js").ObjGen;

export default {
  components: {
    ProductsTable,
    DynamicForm,
    ProductAdvanceFilter,
    DocumentFilter,
    DocumentsTable,
    RteManagement,
    EpayManagement,
    SerialManagement,
    BarcodePrintingTemplate,
  },
  computed: {
    ...mapState([
      "endPoint",
      "serverType",
      "parentId",
      "currentProfile",
      "parameters",
      "categoriesOptions",
    ]),
  },
  created: async function () {
    // reset value to false when this component is remounted
    secureStorage.setItem('fromStockCard', false)
    // before mount so on child mounted it can see the $attrs
    if (this.$attrs.productList != undefined)
      this.params["productList"] = this.$attrs.productList;
    if (this.$attrs.massUpdateMode != undefined) {
      this.params["massUpdateMode"] = this.$attrs.massUpdateMode;
      this.massUpdateMode = this.$attrs.massUpdateMode;
    }

    if (this.$attrs.tableParams != undefined) {
      this.params["tableParams"] = this.$attrs.tableParams;
      this.filterParams = this.$attrs.filterParams;
      this.tags = this.$attrs.tags;
      this.filterKey++;
    }
  },
  mounted: async function () {
    component_x = this;
    var type_doc = this.$route.query.type || "";
    var categoryId = await HTTPRequest.getRequest(
      this.endPoint + "/system_module_categories?code=MDM-001",
      null,
      null
    );
    this.activeModules = await HTTPRequest.getRequest(
      this.endPoint +
        "/system_module_categories/" +
        categoryId[0].id +
        "/enabled_modules",
      null,
      null
    );
    if (type_doc == "OTHPWS") {
      var oth_pws_active_module = this.activeModules.find(
        (e) => e.code == "OTHPWS"
      );
      var profile = _.snakeCase(oth_pws_active_module.name);
      await this.setCurrentProfile(
        _.pluralize(profile),
        oth_pws_active_module.id
      );
      this.documentType = "OTHPWS"
    }else if (type_doc == "OTHBAR"){
      var oth_bar_active_module = this.activeModules.find(
        (e) => e.code == "OTHBAR"
      );
      var profile = _.snakeCase(oth_bar_active_module.name);
      await this.setCurrentProfile(
        _.pluralize(profile),
        oth_bar_active_module.id
      );
      this.documentType = "OTHBAR"
    } else if (this.activeModules.length > 0) {
      var profile = _.snakeCase(this.activeModules[0].name);
      await this.setCurrentProfile(
        _.pluralize(profile),
        this.activeModules[0].id
      );
    } else {
      await this.setCurrentProfile(null, null);
    }

    var options = await HTTPRequest.getRequest(
      this.endPoint + "categories/cascader_view",
      null
    );
    this.updateCategoriesOptions(options);
    component_x.params = "";
    // this.options = await HTTPRequest.getRequest(this.endPoint + '/categories/cascader_view', null)

    // this.updateCurrentProfile("products")
    // this.setCurrentProfile("products", );
  },
  data: function () {
    return {
      docTypeChanged:false,
      activeModules: [],
      searchText: null,
      type: null,
      pxMode: "products",
      category_id: null,
      supplier_id: null,
      brand_id: [],
      sub_brand_id: [],
      divisionList: [],
      divisionId: null,
      departmentList: [],
      departmentId: null,
      sectionList: [],
      sectionId: null,
      classList: [],
      classId: null,
      params: {},
      filterParams: {},
      toggleAdvanceFilter: false,
      toggleLabel: "Advanced Filter",
      options: [],
      data: [],
      suppliers: [],
      brands: [],
      componentKey: 0,
      formSettings: {},
      convertedJson: null,
      categoryLevel: null,
      visible: false,
      categoryRemark: "",
      categoryName: "",
      categoryCode: "",
      defaultExpandAll: true,
      expandedKeys: [],
      searchValue: "",
      autoExpandParent: true,
      formId: "",
      selectedNode: null,
      selectedKey: null,
      currentFilter: "category_id",
      placeholder: this.currentFilter,
      authHeaders: {
        Authorization: "Bearer " + secureStorage.getItem("accessToken"),
        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
      },
      parentParams: {},
      filterCaption: "Search by Barcode",
      filterField: "barcode",
      tags: [],
      filterKey: 0,
      massUpdateMode: false,
      accessRights: [],
      visibleFilter: false,
      filterFields: [],
      selectedDocumentName: null,
      documentType: "OTHPWS",
      documentTypeDetails:{},
      isIncludeMatrixItem: 'true',
    };
  },
  watch: {
    currentFilter: async function () {
      if (this.currentFilter == "supplier_id") {
        var suppliers = await HTTPRequest.getRequest(
          this.endPoint + "/suppliers",
          null
        );
        this.suppliers = suppliers.data;
        this.sort(suppliers);
        //   this.setParentId(0);
      } else if (this.currentFilter == "brand_id") {
        var brands = await HTTPRequest.getRequest(
          this.endPoint + "/brands",
          null
        );
        this.brands = brands.data;
        this.sort(brands);
        //   this.setParentId(0);
      }
    },
    searchValue: async function () {
      if (this.currentFilter == "supplier_id") {
        var suppliers = await HTTPRequest.getRequest(
          this.endPoint + "/suppliers?name=" + this.searchValue,
          null
        );
        this.sort(suppliers);
      } else if (this.currentFilter == "brand_id") {
        var brands = await HTTPRequest.getRequest(
          this.endPoint + "/brands?name=" + this.searchValue,
          null
        );
        this.sort(brands);
      }
    },
  },
  methods: {
    ...mapActions([
      "updateCurrentProfile",
      "updateParentId",
      "updateParameters",
      "updateCategoriesOptions",
      "updateCurrentApiURL",
    ]),
    moment,
    async setCurrentProfile(profile, id) {
      console.log("profilr", profile)
      var accessRightsRequest = await HTTPRequest.getRequest(
        this.endPoint +
          "users/" +
          secureStorage.getItem("userId") +
          "/access_rights?system_module_id=" +
          id,
        null
      );
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id];
      } else {
        this.accessRights = [];
      }
      this.updateCurrentProfile(profile);

      if (profile == "product_price_worksheets" || profile == "barcode_printings") {
        var document_types = await HTTPRequest.getRequest(
          this.endPoint +
            "/document_types/get_document_types_on_system_modules?code=MDM-001",
          null,
          null
        );
        var document_type = document_types[0];
        if (profile == "product_price_worksheets"){
          document_type = document_types.find((v)=> v.type_code == 'PWS')
          this.documentType = "OTHPWS"
        }else if (profile == "barcode_printings"){
          document_type = document_types.find((v)=> v.type_code == 'BAR')
          this.documentType = "OTHBAR"
        }
        this.documentTypeDetails = {documentTypeId:document_type.id,documentTypeName:document_type.name,documentTypeCode:document_type.trans_code+document_type.type_code,documentTypeFriendlyCode:document_type.friendly_code}
        this.setCurrentDocumentType(
          document_type.id,
          document_type.name,
          document_type.trans_code,
          document_type.type_code,
          document_type.friendly_code
        );
        this.docTypeChanged = true
      }
      this.componentKey++;
    },
    setCurrentDocumentType(
      documentTypeId,
      documentTypeName,
      documentTypeTransCode,
      documentTypeCode,
      documentTypeFriendlyCode
    ) {
      var today = moment(new Date());
      var todayMinus30 = moment(new Date()).subtract("30", "days");
      secureStorage.setItem("documentTypeId", documentTypeId);
      secureStorage.setItem("documentTypeName", documentTypeName);
      secureStorage.setItem(
        "documentTypeCode",
        documentTypeTransCode + documentTypeCode
      );
      secureStorage.setItem(
        "documentTypeFriendlyCode",
        documentTypeFriendlyCode
      );
      this.selectedDocumentName = secureStorage.getItem("documentTypeName");
      this.changeDocFilter(
        null,
        todayMinus30.format("YYYY-MM-DD"),
        today.format("YYYY-MM-DD"),
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );
      this.updateCurrentApiURL(
        "documents?document_type_id=" + documentTypeId + this.params + '&call_type=list'
      );
    },
    changeDocFilter(
      filterSite,
      searchDateFrom,
      searchDateTo,
      filterDateBy,
      filterStatus,
      filterOrderStatus,
      filterDocumentCode,
      filterReference,
      filterSupplier,
      filterCreatedBy,
      filterPostedBy,
      filterDeliveryTo,
      filterQuantity,
      filterOrderNo,
      filterOriginNo,
      filterDocumentNo,
      filterPurpose,
      filterOmsStatus,
      filterWmsStatus,
      filterBrands,
      filterBarcode,
      filterOrderType,
      filterCompany,
    ) {
      this.params = "";
      if (filterSite)
        this.params = this.params.concat("&site_id=" + filterSite);
      if (searchDateFrom)
        this.params = this.params.concat("&searchDateFrom=" + searchDateFrom);
      if (searchDateTo)
        this.params = this.params.concat("&searchDateTo=" + searchDateTo);
      if (filterDateBy)
        this.params = this.params.concat("&filter_date_by=" + filterDateBy)
      if (filterStatus)
        this.params = this.params.concat("&status=" + filterStatus);
      if (filterOrderStatus)
        this.params = this.params.concat("&order_status=" + filterOrderStatus);
      if (filterDocumentCode)
        this.params = this.params.concat("&document_no=" + filterDocumentCode);
      if (filterSupplier)
        this.params = this.params.concat("&supplier_id=" + filterSupplier);
      if (filterCreatedBy)
        this.params = this.params.concat("&created_by=" + filterCreatedBy);
      if (filterPostedBy)
        this.params = this.params.concat("&posted_by=" + filterPostedBy);
      if (filterDeliveryTo)
        this.params = this.params.concat("&target_site_id=" + filterDeliveryTo);
      if (filterQuantity)
        this.params = this.params.concat("&order_quantity=" + filterQuantity);
      if (filterOrderNo)
        this.params = this.params.concat("&order_no=" + filterOrderNo);
      if (filterOriginNo)
        this.params = this.params.concat("&order_origin_no=" + filterOriginNo);
      if (filterCompany)
        this.params = this.params.concat("&company_id=" + filterCompany);
      if (filterBrands) 
        this.params = this.params.concat("&brand_id=" + filterBrands)
      if(filterDocumentNo)
        this.params = this.params.concat(
          "&origin_document_id=" + filterDocumentCode
        );
      if(filterReference){
        for(var filter in filterReference){
            // console.log(filter.field)
            this.params = this.params.concat("&" + filterReference[filter]["field"] + "=" + filterReference[filter]["value"])
        }
      }

      this.updateParameters(this.params);
    },
    changeMode(mode, productList, params) {
      this.massUpdateMode = mode;
      this.productList = productList;
      this.filterKey++;
      this.params = params;
    },
    checkFilteringMethod(){
      if(this.massUpdateMode){
        let searchText =  [...new Set(this.searchText.replace(/\s*,\s*/g, ",").split(","))]
        this.massFilterProducts(searchText)
      }else{
        this.filterProducts()
      }
    },
    massFilterProducts(searchText){
      if (this.searchText == null || this.searchText == "") {
        this.$notification["info"]({
          message: "Search text is empty",
          description: "Please input value that you want to search",
        });
      } else {
        searchText.forEach((text) => {
          let concatinatedText = `${this.filterField} : ${text}`
          if(!this.tags.includes(concatinatedText)){
            this.tags = [...this.tags, concatinatedText]
          }
        }) 

         if(!_.isEmpty(this.params)){
          this.parentParams[this.filterField] = [...new Set(`${this.parentParams[this.filterField]},${searchText}`.replaceAll("undefined,", "").split(","))].join(",")
          this.params = Object.assign({}, this.params, this.parentParams);
          // secureStorage.setItem("massFilterParams", this.params)
         }else{
          this.parentParams[this.filterField] = `${searchText}`
          var parametersCopy = this.parentParams;
          this.params = Object.assign({}, this.params, parametersCopy);
         }
          this.searchText = "";
          this.componentKey++;
      }
    },
    filterProducts() {
      if (this.searchText == null || this.searchText == "") {
        this.$notification["info"]({
          message: "Search text is empty",
          description: "Please input value that you want to search",
        });
      } else {
        this.filterFields = Object.keys(this.parentParams);
        if (this.filterFields.includes(this.filterField)) {
          // this.$notification["info"]({
          //   message: "Filter for " + this.filterField + " is already existing",
          //   description: "Please remove existing filter and search again",
          // });

          this.tags.forEach( (field, key) => {
            if (field.startsWith(this.filterField + ":")) {
              // removing tag with the same filter field
              this.tags.splice(key, 1)
            }
          });
          
          // add new filter field
          this.parentParams[this.filterField] = this.searchText;
          this.tags.push(this.filterField + ": " + this.searchText);
          if(this.isIncludeMatrixItem == 'true'){
            this.parentParams["include_matrix_item"] = this.isIncludeMatrixItem
          }
        } else {
          this.parentParams[this.filterField] = this.searchText;
          this.tags.push(this.filterField + ": " + this.searchText);
          if(this.isIncludeMatrixItem == 'true'){
            this.parentParams["include_matrix_item"] = this.isIncludeMatrixItem
          }
        }

          var parametersCopy = this.parentParams;
          // var mergedParameters = Object.assign({}, parametersCopy, this.params);
          var mergedParameters = Object.assign({}, this.params, parametersCopy);
          this.params = mergedParameters;
          this.searchText = "";

          this.componentKey++;
      }
    },
    closeFilter() {
      this.advanceFilter();
    },
    advanceFilter() {
      this.toggleAdvanceFilter = !this.toggleAdvanceFilter
      if (this.toggleAdvanceFilter == true) {
        this.toggleLabel = "Collapse Filter";
      } else {
        this.toggleLabel = "Advanced Filter";
      }
    },
    async changePxMode(value) {
      this.toggleAdvanceFilter = false;
      this.toggleLabel = "Advanced Filter";
      this.pxMode = value;
      if (value == "categories") {
        var division = await HTTPRequest.getRequest(
          this.endPoint + "/categories?level=1",
          null
        );
        this.divisionList = division;
        this.divisionId = null;
        this.departmentList = [];
        this.departmentId = null;
        this.sectionList = [];
        this.sectionId = null;
        this.classList = [];
        this.classId = null;
      }
    },
    changeParams(params, actualParams, mode) {
      this.tags = [];
      var parametersCopy = this.parentParams;
      var mergedParameters = Object.assign({}, parametersCopy, params);


      // console.log("--------------")
      // console.log(mergedParameters)
      console.log("actual params", actualParams)
      console.log("mergedParameters", mergedParameters)
      console.log("copy", parametersCopy)
      this.params = mergedParameters;
      this.filterParams = actualParams;
      this.massUpdateMode = mode;
      const defaultFilters = [
        "status",
        "is_non_trade",
        "stock_status",
        "category_name",
        "supplier_name",
        "start_date",
        "brand_names",
        "sub_brand_names",
        "tag_names",
        "inputCategory",
        "inputBrand",
        "inputSubBrand",
        "inputSupplierType",
        "inputSupplier",
        "inputDate",
        "statusFilter",
        "inputTag",
        "inputProductGroup",
        "product_group_names",
        "inputProductGrade",
        "inputRetailPrice",
        "dateString",
        "isNonTrade",
        "stockStatus",
        "inputProductSeriesName",
        "inputProductSeriesDate",
        "product_series_name",
      ];

      if (Object.keys(this.parentParams)[0] != undefined) {
        this.tags.push(
          Object.keys(this.parentParams)[0] +
            ":" +
            Object.values(this.parentParams)[0]
        );
      }

      Object.keys(params).forEach(function (key) {
        if (!defaultFilters.includes(key)) {
          component_x.tags.push(`${key}: ${params[key]}`);
        }
      });

      if (params["status"] != undefined) {
        switch (params["status"]) {
          case "A":
            this.tags.push("Status: Active");
            break;
          case "I":
            this.tags.push("Status: Inactive");
            break;
          case "P":
            this.tags.push("Status: Phased Out");
            break;
          case "D":
            this.tags.push("Status: Deleted ");
            break;
        }
      }

      if (params["is_non_trade"] != undefined) {
        this.tags.push("Non-trade: " + params["is_non_trade"]);
      }

      if (params["stock_status"] != undefined) {
        switch (params["stock_status"]) {
          case "1":
            this.tags.push("Stock: Out of Stock");
            break;
          case "2":
            this.tags.push("Stock: On Stock");
            break;
          case "3":
            this.tags.push("Stock: Negative Stock");
            break;
        }
      }

      if (params["category_name"] != undefined) {
        this.tags.push("Category: " + params["category_name"]);
      }

      if (params["supplier_name"] != undefined) {
        this.tags.push("Supplier: " + params["supplier_name"]);
      }

      if (params["start_date"] != undefined) {
        this.tags.push(
          "Price Change Date: " +
            params["start_date"] +
            " to " +
            params["end_date"]
        );
      }

      if (params["brand_names"] != undefined) {
        for (var i = 0; i < params["brand_names"].length; i++) {
          this.tags.push("Brand: " + params["brand_names"][i]);
        }
      }

      if (params["sub_brand_names"] != null) {
        params["sub_brand_names"].forEach((el) => {
          this.tags.push("Sub Brand: " + el)
        })
      }


      if (params["product_group_names"] != null) {
        params["product_group_names"].forEach((el) => {
          this.tags.push("Product Group: " + el)
        })
      }

      if (params["product_series_name"] != null) {
        params["product_series_name"].forEach((el) => {
          this.tags.push("Product Series: " + el)
        })
      }

      if (params["tag_names"] != undefined) {
        for (var j = 0; j < params["tag_names"].length; j++) {
          this.tags.push("Tag: " + params["tag_names"][j]);
        }
      }

      if (actualParams == null) {
        this.params = {};
        this.parentParams = {};
        this.tags = [];
      }

      let exclude = ["brand_id", "product_group_id", "sub_brand_id"]
      exclude.forEach((item) => {
        this.tags = this.tags.filter((tag) => {
          return tag.indexOf(item) !== 0;
        })
      })

      this.advanceFilter();
      this.componentKey++;
    },
    
    handleClose(removedTag) {
      const tagArray = removedTag.split(":").map((text) => text.trim());
      
      if (this.massUpdateMode) {
        let updatedValue;
        if (tagArray[0] === "name" || tagArray[0] === "barcode" || tagArray[0] === "stock_no" || tagArray[0] === "reference_code" || tagArray[0] === "shelf_code") {
          // updatedValue = this.parentParams[tagArray[0]].split(",").filter((field) => field != tagArray[1])
          updatedValue = this.params[tagArray[0]].split(",").filter((field) => field != tagArray[1]).join(",")
          if(updatedValue.length === 0){
            delete this.params[tagArray[0]]
          }else{
            this.params = {...this.params, [tagArray[0]] :  updatedValue}
          }
          console.log(this.params)
          this.tags = this.tags.filter((tag) => tag !== removedTag)
        }
      }
        switch (tagArray[0]) {
        case "Supplier":
          delete this.filterParams["inputSupplier"];
          delete this.params["supplier_id"];
          break;
        case "Price Change Date":
          delete this.filterParams["inputDate"];
          delete this.filterParams["dateString"];
          delete this.params["start_date"];
          delete this.params["end_date"];
          break;
        case "Status":
          this.filterParams["statusFilter"] = "0";
          delete this.params["status"];
          break;
        case "Price Change Date":
          this.filterParams["inputDate"] = [];
          break;
        case "Category":
          delete this.filterParams["inputCategory"];
          delete this.params["category_id"];
          delete this.params["section_id"];
          delete this.params["division_id"];
          delete this.params["department_id"];
          break;
        case "Brand":
          var brandIndex = this.params["brand_names"].indexOf(tagArray[1]);
          this.params["brand_id"].splice(brandIndex, 1);
          this.params["brand_names"].splice(brandIndex, 1);
          break;
        case "Sub Brand":
          var subBrandIndex = this.params["sub_brand_names"].indexOf(tagArray[1]);
          this.params["sub_brand_id"].splice(subBrandIndex, 1);
          this.params["sub_brand_names"].splice(subBrandIndex,1);
          break;
        case "Product Group":
          var productGroupIndex = this.params["product_group_names"].indexOf(tagArray[1]);
          this.params["product_group_id"].splice(productGroupIndex, 1);
          this.params["product_group_names"].splice(productGroupIndex, 1);
          break;
        case "Product Series":
          var productSeriesIndex = this.params["product_series_name"].indexOf(tagArray[1]);
          this.params["product_series_name"].splice(productSeriesIndex, 1);
          break;
        case "Tag":
          var tagIndex = this.params["tag_names"].indexOf(tagArray[1]);
          this.params["product_line_id"].splice(tagIndex, 1);
          this.params["tag_names"].splice(tagIndex, 1);
          // this.filterParams["inputTag"].splice(tagIndex, 0)
          break;
        case "name":
            if (!this.massUpdateMode) {
              delete this.parentParams["name"];
              delete this.params["name"];
            }
          break;
        case "barcode":
            if (!this.massUpdateMode) {
              delete this.parentParams["barcode"];
              delete this.params["barcode"];
            }
          break;
        case "stock_no":
            if (!this.massUpdateMode) {
              delete this.parentParams["stock_no"];
              delete this.params["stock_no"];
            }
          break;
        case "reference_code":
            if (!this.massUpdateMode) {
              delete this.parentParams["reference_code"];
              delete this.params["reference_code"];
            }
          break;
        case "shelf_code":
            if (!this.massUpdateMode) {
              delete this.parentParams["shelf_code"];
              delete this.params["shelf_code"];
          }
          break;
        case "Non-trade":
          delete this.parentParams["is_non_trade"];
          delete this.params["is_non_trade"];
          break;
        case "Stock":
          delete this.filterParams["stockStatus"];
          delete this.params["stock_status"];
          delete this.parentParams["stock_status"];
          break;
        default:
          // console.log(`***** ${tagArray[0]}`);
          delete this.filterParams[tagArray[0]];  
          delete this.params[tagArray[0]];
          delete this.parentParams[tagArray[0]];
          break;
      }

      if(!this.massUpdateMode){
        const tags = this.tags.map((tag) => tag !== removedTag);
        this.tags = tags;
      }
      this.filterKey++;
      this.componentKey++;
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },

    onRowClass(id) {
      return id == this.parentId ? "alert-success" : "";
    },
    sort(data) {
      data = data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.data = data;
    },
    setParentId(id) {
      this.updateParentId(id);
      if (this.currentFilter == "brand_id") {
        this.updateParameters("?brand_id=" + this.parentId);
      } else if (this.currentFilter == "supplier_id") {
        this.updateParameters("?supplier_id=" + this.parentId);
      }
    },
    async showDrawer(type, mode, category) {
      this.formId = type;
      this.visible = true;
      var jsonField;
      if (type == "addCategory") {
        this.clearData();
        switch (mode) {
          case "division":
            this.selectedKey = -1;
            this.categoryLevel = 1;
            break;
          case "department":
            this.selectedKey = this.divisionId;
            this.categoryLevel = 2;
            break;
          case "section":
            this.selectedKey = this.departmentId;
            this.categoryLevel = 3;
            break;
          case "class":
            this.selectedKey = this.sectionId;
            this.categoryLevel = 4;
            break;
        }
        this.categoryName = "New Level " + this.categoryLevel.toString();
        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(
            this.endPoint +
              "dynamic_forms/Product Category?field_name=profile_name",
            null,
            null
          );
          this.convertedJson = ObjGen.xJson(jsonField.template, {
            numSpaces: 2,
          });
        }
      }

      if (type == "editCategory") {
        switch (mode) {
          case "division":
            this.categoryLevel = 1;
            break;
          case "department":
            this.categoryLevel = 2;
            break;
          case "section":
            this.categoryLevel = 3;
            break;
          case "class":
            this.categoryLevel = 4;
            break;
        }
        this.selectedKey = category.id;
        this.categoryName = category.name;
        this.categoryCode = category.code;
        this.categoryRemark = category.remark;

        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(
            this.endPoint +
              "dynamic_forms/Product Category?field_name=profile_name",
            null,
            null
          );
          this.convertedJson = ObjGen.xJson(jsonField.template, {
            numSpaces: 2,
          });

          var formSettings = await HTTPRequest.getRequest(
            this.endPoint + "categories/" + category.id + "/get_settings",
            null,
            null
          );
          this.formSettings = JSON.parse(formSettings["settings"]);
          this.componentKey++;
        }
      }

      if (this.serverType == "branch") {
        var form = document.getElementById("form-proper");
        var elements = form.elements;
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].readOnly = true;
        }
      }
    },
    changeFilter(field) {
      this.filterField = field;
      this.filterCaption = "Search by " + _.startCase(this.filterField);
      // this.isIncludeMatrixItem = 'false';
    },
    clearFilter(){  
      this.tags = [];
      this.parentParams = {}
      this.params = {};  
      // this.isIncludeMatrixItem = 'false'
      this.componentKey++;
    },
  },
};
</script>

<style>
.selected2 {
  background-color: #eff6ff;
  color: #2371cc;
}
</style>
